<template>
  <div>
    <v-card class="pa-2 mb-2">
      <v-layout row wrap align-center>
        <v-flex xs12 sm5 md4 class="px-2">
          <v-select :value="selectedBusiness" :items="businesses" item-text="name" item-value="id"
            :label='$t("passengersPage.filterByEstablishment")' clearable hide-details @input="setBusiness" />
        </v-flex>
        <!-- Owner item 3.1: Active / Inactive / Banned. Kept outside the
             DataTable, whose toolbar disappears on an empty page. -->
        <v-flex xs12 sm7 md8 class="px-2">
          <account-state-filter
            entity="passenger"
            :value="accountState"
            :counts="stateCounts"
            :window-days="stateWindowDays"
            :counts-failed="stateCountsFailed"
            @input="setAccountState"
          />
        </v-flex>
      </v-layout>
    </v-card>
    <DataTable :url="api.ACTIONS.PASSENGERS" ref="list" :perPage="'25'" :enable-add="false" :enable-edit="false"
      :enable-delete="false" :formatter="formatter" :actions-extra-main="actions" :conditional-action="conditionalActions"
      :initial-url-search-params="typeParams" :initial-search="listSearch" :fields-hidden-main="[
        'type',
        'approved_at',
        'username',
        'active',
        'establishment_id',
        'blacklisted_at',
        'blacklist_note',
      ]" :fields-unsortable="['account_state']" :titles="titles" :title='$t("passengersPage.normalAccounts")'/>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import AccountStateFilter from "@/components/AccountStateFilter";
import accountStateFilterMixin from "@/mixins/accountStateFilterMixin";
import { accountStateLabelHtml } from "@/constants/accountState";

export default {
  name: "RegisteredPassengers",
  title: "passengersPage.pageTitle",
  components: { DataTable, AccountStateFilter },
  mixins: [accountStateFilterMixin],
  data() {
    return {
      businesses: [],
    };
  },
  mounted() {
    this.axios
      .get("business-account", { params: { perPage: 1000 } })
      .then(({ data }) => {
        this.businesses = (((data.data && data.data.data) || [])).map((b) => ({ id: b.id, name: b.name }));
      })
      .catch(() => {});
  },
  computed: {
    // The establishment filter lives in ?business_id= next to ?state=: a
    // filter change remounts the page (accountStateFilterMixin), so local
    // state would not survive a chip click.
    selectedBusiness() {
      const raw = this.$route.query.business_id;
      return /^\d+$/.test(String(raw)) ? Number(raw) : null;
    },
    titles() {
      return {
        id: this.$t("passengersPage.id"),
        full_name: this.$t("passengersPage.fullName"),
        phone_number: this.$t("passengersPage.phoneNumber"),
        establishment_name: this.$t("passengersPage.business"),
        gender: this.$t("passengersPage.gender"),
        birthday: this.$t("passengersPage.dateOfBirth"),
        email: this.$t("passengersPage.email"),
        account_state: this.$t("accountState.label"),
        created_at: this.$t("passengersPage.creationDate"),
        version: this.$t("passengersPage.appVersion"),
        platform: this.$t("passengersPage.platform"),
      };
    },
    typeParams() {
      const params = new URLSearchParams();
      params.append("type", "NORMAL");
      if (this.selectedBusiness) params.append("business_id", this.selectedBusiness);
      if (this.accountState !== "all") params.append("account_state", this.accountState);
      return params;
    },
    // Read by accountStateFilterMixin: the chip counts follow the
    // establishment filter.
    stateCountsUrl() {
      return this.api.ACTIONS.PASSENGER_STATE_COUNTS;
    },
    stateCountsParams() {
      const params = { type: "NORMAL" };
      if (this.selectedBusiness) params.business_id = this.selectedBusiness;
      return params;
    },
    actions() {
      return {
        edit: {
          title: this.$t("passengersPage.viewProfile"),
          icon: "info",
          action: (item) => {
            this.$router.push({ path: `/passengers/${item.id}` });
          },
        },
      };
    },
    conditionalActions() {
      return {};
    },
    formatter() {
      const vm = this;
      return {
        establishment_name(val) {
          return val || vm.$t("passengersPage.notAffiliated");
        },
        // Owner item 3.1: replaces the old tick/cross of blacklisted_at.
        account_state(val) {
          return accountStateLabelHtml(val, (key) => vm.$t(key));
        },
        gender(val) {
          if (val === null || val === undefined) return "";
          // Backend: 0 = Male, 1 = Female
          return String(val) === "1"
            ? vm.$t("passengersPage.male")
            : vm.$t("passengersPage.female");
        },
        birthday(value) {
          if (!value) return "";
          return formatCompanyTime(value, "DD-MM-YYYY");
        },
        created_at(value) {
          if (!value) return "";
          return formatCompanyTime(value, "DD-MM-YYYY  HH:mm");
        },
      };
    },
  },
  methods: {
    setBusiness(id) {
      const next = id === null || id === undefined || id === "" ? null : Number(id);
      if (next === this.selectedBusiness) return;
      const query = { ...this.$route.query };
      if (next === null) delete query.business_id;
      else query.business_id = String(next);
      this.replaceListQuery(query);
    },
  },
};
</script>

<style scoped></style>
